// extracted by mini-css-extract-plugin
export default {"asideItem":"style_asideItem__LZ5LU"};